import { styled } from '@mui/material';

import { ButtonBase } from '../ButtonBase';
import { iconButtonGhostClasses } from './theme';

import type { IconButtonGhostOwnerState, IconButtonGhostProps } from './types';

export default function IconButtonGhost(props: IconButtonGhostProps) {
  const { children, variant = 'primary', size = 'xl', disabled = false, ...others } = props;

  const ownerState: IconButtonGhostOwnerState = {
    ...props,
    variant,
    size,
    disabled,
  };

  return (
    <IconButtonGhostRoot
      appearance="ghost"
      content="icon"
      variant={variant}
      size={size}
      disabled={disabled}
      ownerState={ownerState}
      {...others}
    >
      {children}
    </IconButtonGhostRoot>
  );
}
IconButtonGhost.displayName = 'IconButtonGhost';

const IconButtonGhostRoot = styled(ButtonBase, {
  target: iconButtonGhostClasses.root,
})<{ ownerState: IconButtonGhostOwnerState }>``;
